import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { RefreshCw, ExternalLink } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState({ 
    username: "", 
    password: "" 
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(loginData.username, loginData.password);
      toast.success("Giriş başarılı!");
    } catch (error) {
      const msg = error.message?.includes('bağlanılamıyor') || error.message?.includes('SSL')
        ? error.message
        : (error.response?.data?.detail || "Giriş yapılamadı");
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 login-bg">
      <div className="absolute inset-0 login-overlay" />
      
      <Card className="w-full max-w-md relative z-10 shadow-2xl border-0">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-slate-900 rounded-xl flex items-center justify-center">
              <RefreshCw className="w-8 h-8 text-white" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-slate-900">Shopify - Nebim V3</CardTitle>
          <CardDescription className="text-slate-500">Nebim Hesabınızla Giriş Yapın</CardDescription>
        </CardHeader>
        
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username">Kullanıcı Adı</Label>
              <Input
                id="username"
                type="text"
                placeholder="Nebim kullanıcı adınız"
                value={loginData.username}
                onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
                required
                data-testid="username-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Şifre</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={loginData.password}
                onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                required
                data-testid="password-input"
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit-btn">
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
          </form>
        </CardContent>
      </Card>
      
      {/* Nebim Özel Sistemi - Card dışında */}
      <div className="relative z-10 mt-6 text-center">
        <p className="text-white text-sm font-medium mb-3">Nebim Özel Sistemi</p>
        <div className="flex justify-center gap-4">
          <a 
            href="https://bogazicisoft.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-white/70 hover:text-white flex items-center gap-1 transition-colors"
          >
            BoğaziçiSoft <ExternalLink className="w-3 h-3" />
          </a>
          <a 
            href="https://raftakip.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-white/70 hover:text-white flex items-center gap-1 transition-colors"
          >
            Raf Takip <ExternalLink className="w-3 h-3" />
          </a>
          <a 
            href="https://urunbulur.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-white/70 hover:text-white flex items-center gap-1 transition-colors"
          >
            Ürün Bulur <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>
    </div>
  );
}
